module.exports = __webpack_public_path__ + "static/caesars-logo-97e5b0a72286b90a1ac0fd02ae97d6ad.png";